<template>
    <div>
        <rkm-form ref="RkmForm">
            <rkm-row>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        :repository="repositories.medicamento"
                        :request-query-string-params="requestQueryStringParams"
                        :results-limit="20"
                        :search-fields="fields.autocomplete"
                        :validations="validations.medicamento"
                        label="Medicamento"
                        text-field="descricao"
                        v-model="model.medicamento"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="include"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="reset"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-row>
            <rkm-col>
                <rkm-table
                    :fields="fields.table"
                    :items="data.model.integracaoBnafarMedicamentos"
                >
                    <template v-slot:cell(actions)="{item}">
                        <rkm-button
                            @click="destroy(item)"
                            color="danger"
                            small
                            title="Excluir"
                        >
                            <rkm-icon icon="trash" />
                        </rkm-button>
                    </template>
                </rkm-table>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

export default {
    computed: {
        requestQueryStringParams() {
            const ids = this.data.model.integracaoBnafarMedicamentos.map(integracaoBnafarMedicamento => integracaoBnafarMedicamento.medicamentoId)

            return {ids}
        },
        validations() {
            return {
                medicamento: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            medicamento: this.getConectaSusRepository('integracao.bnafar.medicamento'),
        }
    },
    data: () => ({
        fields: {
            autocomplete: [
                {key: 'descricao', searchable: true},
            ],
            table: [
                {key: 'medicamentoCodigo', label: 'Código'},
                {key: 'medicamentoDescricao', label: 'Descrição'},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ],
        },
        model: {
            medicamento: null,
        },
    }),
    methods: {
        include() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.data.model.integracaoBnafarMedicamentos.find(integracaoBnafarMedicamento => integracaoBnafarMedicamento.medicamentoId === this.model.medicamento.id)) {
                        this.showValidationNotification('O medicamento já foi incluído.')
                        return
                    }

                    const cadastroMaterialIntegracaoBnafarMedicamento = {
                        medicamentoId: this.model.medicamento.id,
                        medicamentoCodigo: this.model.medicamento.codigo,
                        medicamentoDescricao: this.model.medicamento.descricao,
                    }

                    this.data.model.integracaoBnafarMedicamentos.push(cadastroMaterialIntegracaoBnafarMedicamento)

                    this.reset()
                })
        },
        destroy(item) {
            this.showDeleteConfirmation('Deseja realmente excluir o medicamento?', async () => {
                this.data.model.integracaoBnafarMedicamentos.splice(this.data.model.integracaoBnafarMedicamentos.indexOf(item), 1)
            })
        },
        reset() {
            this.model.medicamento = null
            this.$refs.RkmForm.resetValidator()
        },
    },
    mixins: [error, repository],
    props: {
        data: {type: Object, required: true},
    },
}
</script>
